import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
// 重写 router push 方法， 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
const routes = [{
		path: '/', //如果是根路径就重定向到login页面
		redirect: 'Login'
	}, {
		//如果浏览器url是'/login'路径，就找 import ('../views/Login.vue')这个页面渲染
		path: '/login',
		name: 'Login',
		meta: {
			title: '后台管理登录',
			requiredPath: false,
		},
		component: () =>
			import('../pages/login/login.vue')
	}, {
		//如果浏览器url是'/login'路径，就找 import ('../views/Login.vue')这个页面渲染
		path: '/myMap',
		name: 'myMap',
		meta: {
			title: '后台管理登录',
			requiredPath: false,
		},
		component: () =>
			import('../components/map/myMap.vue')
	}

]

const router = new VueRouter({
	mode: 'hash', //history
	routes
})

// 进入之前路由元信息配置守卫 requiredPath为true, 适合守卫多个页面 vue3next() 变成return true
router.beforeEach((to, from, next) => {
	// console.log(to)
	// console.log(from)
	// console.log(next)
	if (sessionStorage.getItem('token')) {
		next()
	} else {
		if (to.meta.requiredPath) { //没有token requiredPath为true 守卫不让进,跳入login
			next('/Login')
		} else {
			next()
		}
	}
})
// 导航后置守卫(当你真正进入到某个页面之后才执行)
// router.afterEach((to, from) => {
//     // 设置路由的标题 (可自定义)
//     document.title = to.meta.title || '后台'
//         // 将所有的页面切换之后滚动到最顶部
//     window.scrollTo(0, 0);
// })
export default router
